import { NodeIndexOutlined, TableOutlined } from '@ant-design/icons'
import { GraphView, SpreadSheetView } from 'Model'
import { Graph, SpreadSheet } from './FormItems'

export GRAPH_VIEW = {
  title: 'Graph view'
  description: 'Opens a graph based on a query'
  icon: <NodeIndexOutlined />
  Constructor: GraphView
  queryLang: 'QueryBuilder'
  FormItems: Graph
}
